
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.666 11.25h6.667M6.666 7.083h3.333","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.082 15.833c-1.084-.106-1.895-.432-2.44-.976-.976-.976-.976-2.548-.976-5.69V8.75c0-3.143 0-4.714.976-5.69.977-.977 2.548-.977 5.69-.977h3.334c3.143 0 4.714 0 5.69.977.977.976.977 2.547.977 5.69v.417c0 3.142 0 4.714-.977 5.69-.976.976-2.547.976-5.69.976-.467.01-.84.046-1.205.13-.998.23-1.923.74-2.837 1.186-1.302.635-1.953.953-2.362.655-.781-.582-.017-2.386.154-3.22","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    